export const TERTIARY = {
  DEFAULT: '#F0F5F4',
  LIGHT: '#F0F5F4',
  LIGHTER: '#F0F5F4',
  LIGHTEST: '#F0F5F4',
} as const;
